module.exports = __webpack_public_path__ + "static/img/btn_1.de68140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/btn_1.png
// module id = NwPz
// module chunks = 1 3